import React from 'react';

const YellowAirplaneRight = () => {
    return (
        <svg
            width="80"
            height="56"
            viewBox="0 0 80 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="80" height="56" rx="28" fill="#FFC24C" />
            <path
                d="M52.3212 28.5829C52.5328 28.4654 52.6641 28.2423 52.6641 28.0002C52.6641 27.7581 52.5328 27.535 52.3212 27.4174L49.2781 25.7268C43.2827 22.396 36.9626 19.6867 30.4163 17.641L29.5296 17.3638C29.3272 17.3006 29.1067 17.3374 28.9358 17.463C28.765 17.5887 28.6641 17.7881 28.6641 18.0002V25.6668C28.6641 26.0214 28.9416 26.3139 29.2957 26.3326L30.6419 26.4034C33.924 26.5762 37.1861 27.0213 40.3946 27.7343L40.7123 27.8049C40.783 27.8206 40.8136 27.8495 40.8307 27.8725C40.8522 27.9014 40.8689 27.946 40.8689 28.0002C40.8689 28.0543 40.8522 28.0989 40.8307 28.1278C40.8136 28.1508 40.783 28.1797 40.7123 28.1954L40.3946 28.266C37.1862 28.979 33.924 29.4242 30.6418 29.5969L29.2957 29.6678C28.9416 29.6864 28.6641 29.9789 28.6641 30.3335V38.0002C28.6641 38.2122 28.765 38.4117 28.9358 38.5373C29.1067 38.6629 29.3272 38.6997 29.5296 38.6365L30.4164 38.3594C36.9626 36.3137 43.2827 33.6043 49.278 30.2736L52.3212 28.5829Z"
                fill="#F7F8F7"
            />
        </svg>
    );
};

export default YellowAirplaneRight;
